import { IonIcon } from "@ionic/react";
import { xMarkIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { checkIcon } from "@/lib/icons/check.icon";
import { hourglassIcon } from "@/lib/icons/hourglass.icon";
import { cn } from "@/lib/style/cva.config";
import { ReserveBadge } from "./reserve-badge";

export type Status = "PENDING" | "ACCEPTED" | "REJECTED" | "RESERVE";

interface StatusConfig {
  icon: string;
  text: string;
}

const statusConfigs: Record<Exclude<Status, "RESERVE">, StatusConfig> = {
  PENDING: {
    icon: hourglassIcon,
    text: "Pending",
  },
  ACCEPTED: {
    icon: checkIcon,
    text: "Accepted",
  },
  REJECTED: {
    icon: xMarkIcon,
    text: "Rejected",
  },
};

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  if (status === "RESERVE") {
    return <ReserveBadge className={className} />;
  }

  const config = statusConfigs[status];

  return (
    <div className={cn("flex items-center gap-2 rounded-full px-3 py-1", className)}>
      <IonIcon icon={config?.icon} className={cn("size-4 text-brand-500")} />
    </div>
  );
}
